import { render } from "./RegisterButtonGiftCardDialog.vue?vue&type=template&id=22d1e75a&scoped=true"
import script from "./RegisterButtonGiftCardDialog.vue?vue&type=script&lang=js"
export * from "./RegisterButtonGiftCardDialog.vue?vue&type=script&lang=js"

import "./RegisterButtonGiftCardDialog.vue?vue&type=style&index=0&id=22d1e75a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d1e75a"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QInput,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
